import React, { Dispatch, JSX, useRef } from 'react';
import { Button, Input } from 'reactstrap';
import { Error, Info, useTranslation, Warning } from '@ibe/components';
import Keys from '../../../Translations/generated/Checkout.de.json.keys';
import fallback from '../../../Translations/generated/Checkout.de.json';
import ContentContainer from '../../../Components/ContentContainer';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type ValidationResult = 'ERROR' | 'VALID' | 'NUMBER_MISMATCH' | 'NOT_SET';

const LoyaltyCard = ({
  cardNumber,
  setCardNumber,
  onSubmit,
  handleClearClick,
  cardValid
}: {
  cardNumber: string | null;
  setCardNumber: Dispatch<React.SetStateAction<string | null>>;
  onSubmit: () => void;
  handleClearClick: () => void;
  cardValid: ValidationResult;
}): JSX.Element => {
  const { t } = useTranslation('Checkout', fallback);
  const inputRef = useRef<HTMLInputElement>(null);
  const isCardNumber10Digits = !!cardNumber && cardNumber !== '' && cardNumber.length === 10;

  return (
    <ContentContainer>
      <fieldset>
        <legend className={'legend-no-style'}>
          <div className="font-weight-bold mb-4">{t(Keys.loyaltyCard)}</div>
        </legend>
        <div className="font-weight-bold mb-4">{t(Keys.loyaltyCardSubText)}</div>
        {cardValid === 'ERROR' && <Error message={t(Keys.loyaltyCardNotValid)} />}
        {cardValid === 'VALID' && <Info message={t(Keys.loyaltyCardValid)} />}
        {cardValid === 'NUMBER_MISMATCH' && <Warning message={t(Keys.loyaltyCardNumberMismatch)} />}
        <div className="loyaltyCard__input">
          <div className="loyaltyCard__input__inner">
            <Input
              innerRef={inputRef}
              type={'text'}
              value={cardNumber ? cardNumber : ''}
              onChange={(e): void => {
                setCardNumber(e.target.value);
              }}
              maxLength={10}
            />
            {cardNumber && <FontAwesomeIcon icon={faTimesCircle} onClick={handleClearClick} />}
          </div>

          <Button onClick={onSubmit} disabled={!isCardNumber10Digits}>
            {t(Keys.loyaltyCardSubmit)}
          </Button>
        </div>
      </fieldset>
    </ContentContainer>
  );
};

export default LoyaltyCard;
